import React from 'react';
import clsx from 'clsx';
import { FormControl, Grid, TextField, makeStyles, InputAdornment, InputLabel, OutlinedInput, IconButton, Button } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { login, logout } from '../../store/auth';
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  spacing: {
    marginBottom: '12px' 
  },
  userInput: {
    width: '80%',
    backgroundColor: 'white',
  },
  userButtons: {
    width: '80%',
    marginTop: '5px'
  }
}));

export default function Auth(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const loginError = useSelector(state => state.auth.error)
 
  const [values, setValues] = React.useState({
    username: '',
    password: '',
    showPassword: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleLogin = (ev) => {
    dispatch(login(values.username, values.password)).then(() => {props.history.push('/flights')})
  }

  const handleLogout = () => {
    dispatch(logout())
  }

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Grid container style={{marginTop: '15%'}} justify="center">
      <Grid container style={{minWidth: '30vmax', maxWidth: '30vmax', padding: '10px 10px 10px 10px', border: '2px solid gray', borderRadius: '15px'}}>
        <Grid item xs={12}>
          <TextField
            label="Username"
            // id="outlined-basic"
            className={clsx(classes.margin, classes.spacing, classes.userInput)}
            variant="outlined"
            value={values.username}
            onChange={handleChange('username')}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl className={clsx(classes.margin, classes.textField, classes.spacing, classes.userInput)} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={values.showPassword ? 'text' : 'password'}
              value={values.password}
              onChange={handleChange('password')}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
          </FormControl>
        </Grid>
        <Grid container item xs={12} justify="center" className={classes.userButtons}>
          <Button variant="contained" color="primary" onClick={handleLogin}>Submit</Button>
        </Grid>
        <Grid container item xs={12} justify="center" className={classes.userButtons}>
          <Button variant="contained" onClick={handleLogout}>Logout</Button>
        </Grid>
        <Grid item xs={12}>
          <p style={{color:'red'}}>{loginError ? 'Incorrect username or password' : ''}</p>
        </Grid>
      </Grid>
    </Grid>
  );
}